import { BULLETIN_DOCUMENT_TYPE } from 'src/utils/bulletin-document-upload';
import { IAdminBulletinItem } from 'src/services/models/bulletins.service';
import {
    BULLETIN_COUNTRY_NONE,
    formatDate,
    formatDateForApi,
    formatDateOnly,
} from 'src/utils/bulletins';

/**
 * Same payload as an edit, with the end date set to today. The backend stores
 * dates without time, so "today" is the closest value to the expiration moment.
 */
export const buildExpireBulletinPayload = (item: IAdminBulletinItem) => {
    const country = String(item.country ?? '').trim();

    return {
        id: item.bulletinId,
        documentId: item.documentId,
        documentType: BULLETIN_DOCUMENT_TYPE,
        bulletinType: item.bulletinType,
        bulletinNumber: String(item.bulletinNumber ?? ''),
        distributionId: item.distributionId,
        title: item.title,
        validFromDate: formatDateOnly(item.validFrom),
        validThroughDate: formatDateForApi(formatDate(new Date())),
        language: item.bulletinLanguage,
        country: country || BULLETIN_COUNTRY_NONE,
        visualStyles: item.visualStyles || '{}',
    };
};
